import { Modal } from "antd";
import SendReminder from "../../../molecules/cards/queue/send-reminder";
import useQueueStore from "../../../stores/queue-store";
import { QUEUE_TYPE } from "@elixir/types";
import { XMarkRegularIcon } from "@elixir/icons";

const SendReminderModal = () => {
  const selectedAppointment = useQueueStore(
    (state) => state.selectedAppointment
  );
  const showSendReminderModal = useQueueStore(
    (state) => state.showSendReminderModal
  );
  const setSelectedAppointment = useQueueStore(
    (state) => state.setSelectedAppointment
  );
  const setShowSendReminderModal = useQueueStore(
    (state) => state.setShowSendReminderModal
  );
  const leftPanelQueueType = useQueueStore((state) => state.leftPanelQueueType);

  const handleClose = () => {
    setSelectedAppointment(undefined);
    setShowSendReminderModal(false);
  };

  if (!showSendReminderModal || !selectedAppointment) {
    return null;
  }
  return (
    <Modal
      style={{
        padding: 0,
        borderRadius: "0.5rem",
        overflow: "hidden",
      }}
      bodyStyle={{ padding: 0 }}
      footer={null}
      closable={false}
      open={showSendReminderModal && !!selectedAppointment}
      zIndex={1100}
      onCancel={handleClose}
      destroyOnClose={true}
    >
      <SendReminder
        data={selectedAppointment}
        queueType={leftPanelQueueType as QUEUE_TYPE}
        onClose={handleClose}
        showCloseIcon={true}
        HeaderComponent={() => (
          <SendReminderHeaderComponent handleClose={handleClose} />
        )}
      />
    </Modal>
  );
};

const SendReminderHeaderComponent = ({
  handleClose,
}: {
  handleClose: () => void;
}) => {
  return (
    <div className="dr-flex dr-justify-between dr-p-16 dr-items-center">
      <div className="Title3Regular text-center">Send Reminder</div>
      <XMarkRegularIcon
        className="dr-w-16 dr-h-16 dr-cursor-pointer"
        onClick={handleClose}
      />
    </div>
  );
};

export default SendReminderModal;
